/**
 * Modal de **confirmación de borrado** (genérico para sedes y atendidos).
 *
 * Réplica de la confirmación del SSR (botón "Eliminar" con confirmación). Recibe
 * el estado de la mutación (pendiente/error) del padre, que es quien dispara el
 * borrado; este componente solo confirma y muestra el error de la API si lo hay
 * (p. ej. 409 con datos asociados). Controlado por `open` del padre.
 */
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui";

interface ConfirmDeleteDialogProps {
  open: boolean;
  title: string;
  /** Texto descriptivo (qué se elimina). */
  description: string;
  /** Mensaje de error de la API a mostrar (si lo hay). */
  errorMessage?: string | null;
  isPending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmDeleteDialog({
  open,
  title,
  description,
  errorMessage,
  isPending,
  onConfirm,
  onClose,
}: ConfirmDeleteDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          onClose();
        }
      }}
    >
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>

        {errorMessage && (
          <p role="alert" className="mt-4 text-sm text-red-600">
            {errorMessage}
          </p>
        )}

        <div className="mt-6 flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={isPending}>
            Cancelar
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={isPending}>
            {isPending ? "Eliminando…" : "Eliminar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
